import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) { }

  async canActivate(): Promise<boolean> {
    if (this.authenticationService.auth.token) {
      try {
        const response = await this.authenticationService.checkAuthentication() as any;
        if (response.success) {
          this.router.navigate(['/']);
          return false;
        } else {
          return true;
        }
      } catch (error) {
        console.error('Error checking authentication:', error);
        return true;
      }
    } else {
      return true;
    }
  }
}
